import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { PickMatchRecord } from "slotworks/model/gameplay/records/pick-match-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class ThemeIsRecoveryFreespinsTriggeredDecision extends Decision {
    public evaluate(): Exit {
        const gameplay: Gameplay = gameState.getCurrentGame();
        let record: Record = gameplay.getCurrentRecord();

        const wasPlayingBonus: boolean = record instanceof PickMatchRecord;

        if (!(record instanceof SpinRecord)) {
            record = gameplay.getRootRecord();
        }

        return wasPlayingBonus && record.getFreespinsWon() > 0 ? Exit.True : Exit.False;
    }
}
